<template>
  <div class="eft-details-main">
    <div :style="{ width: showDetails ? '50%' : '100%' }">
      Electronic Fund Transfer
      <div v-if="!viewMode" class="add-remove-eft">
        <button @click="addClicked" :disabled="showDetails">Add</button>
        <button @click="deleteClicked" :disabled="showDetails" style="margin-left: 3px">Delete</button>
      </div>
      <TableBox title="Bank Details" style="height: calc(100% - 57px)" :additionalButtons="viewMode ? [] : editButtons" :tableData="eftList"
        :selectedRow.sync="selectedEft" :maxSelection="-1" :hideColumns="[ 'eftaction' ]" @buttonClicked="editClicked" />
    </div>
    <div v-if="showDetails" :style="{ marginLeft: '5px', width: showDetails ? '50%' : '0' }">
      <div style="display: flex; justify-content: flex-end; margin-bottom: 5px">
        <button @click="saveClicked">{{editMode ? 'Edit ' : 'Add '}}</button>
        <button @click="cancelClicked" style="margin-left: 5px">Cancel</button>
      </div>
      <Input placeholder="Ref ID" :inputValue.sync="refid" :isDisabled="true" :isRequired="true" />
      <div style="display: flex">
        <InputQuery placeholder="Bank Swift Code" :isRequired="true" :items="bankSwiftCodeItems" itemKey="Bank Swift Code"
        descKey="Bank Swift Code" :selectedObject.sync="selectedBankSwiftCode" :errorMessage.sync="bankSwiftCodeError" @selected="autofillBankDetails" />
        <Input style="margin-left: 5px" placeholder="Bank Account" :inputValue.sync="bankAccount" :isRequired="true" :regex="bankAccountRegex" :errorMessage.sync="bankAccountError" :isEFTAccountNo="bankAccountNumberCheck" ref="bankAccount" />
      </div>
      <div style="display: flex">
        <Input style="width: 50%" placeholder="Bank City" :inputValue.sync="bankCity" :isRequired="true" :errorMessage.sync="bankCityError" />
        <CheckBox title="Default Account" style="margin-left: 5px" :isChecked.sync="isDefaultAccount" :isDisabled="viewMode || checkboxDisabled" />
      </div>
      <Input placeholder="Bank Name" :inputValue.sync="bankName" :isRequired="true" :errorMessage.sync="bankNameError" />
      <Input placeholder="Bank Branch Name" :inputValue.sync="bankBranchName" :errorMessage.sync="bankBranchNameError" />
      <Input placeholder="Remittance Advice E-mail" :inputValue.sync="remittanceAdviceEmail" :errorMessage.sync="remittanceAdviceEmailError" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      showDetails: false,
      editMode: false,
      editButtons: [
        { text: 'Edit', index: 0, width: 60 }
      ],
      editIndex: -1,

      eftList: [],
      selectedEft: [],

      checkboxDisabled: false,
      defaultAccountID: 0,

      refid: '',
      selectedBankSwiftCode: null, bankSwiftCodeItems: [], bankSwiftCodeError: '',
      bankAccount: '', bankAccountError: '',
      bankAccountRegex: {
        regex: /\d/g,
        live: true,
        autoClear: false
      },
      bankCity: '', bankCityError: '',
      isDefaultAccount: false,
      bankName: '', bankNameError: '',
      bankBranchName: '', bankBranchNameError: '',
      remittanceAdviceEmail: '', remittanceAdviceEmailError: '',

      lastUpdate: '',
    }
  },
  computed: {
    bankAccountNumberCheck: function() {
      if (!this.selectedBankSwiftCode || Object.keys(this.selectedBankSwiftCode).length === 0) {
        return null;
      }

      return {
        swiftCode: this.selectedBankSwiftCode["Bank Swift Code"],
        paymentType: "",
        message: "",
        force: true,
        autoClear: false,
      };
    },
  },
  props: {
    viewMode: { type: Boolean, default: false },
    showInputs: { type: Boolean, default: false }, // show/hide input fields, use .sync
    eft: { type: Array, default: function() { return [] } }
  },
  methods: {
    addClicked: function() {
      this.clearFields();
      this.showDetails = true;
      this.editMode = false;
      this.$emit("update:showInputs", true);
      if (this.eftList.length < 1) {
        this.isDefaultAccount = true;
        this.checkboxDisabled = true;
      }
    },
    editClicked: function(btn, data) {
      this.editMode = true;
      this.$emit("update:showInputs", true);
      if (this.viewMode) return;
      this.showDetails = true;
      this.editIndex = this.eftList.findIndex(l => l['eftid'] === data['eftid']);
      this.populateEditData(data);
    },
    populateEditData: function(data) {
      if (this.eftList.length == 1) {
        this.checkboxDisabled = true;
      }

      this.refid = data['eftid'];
      let bsc = data['bankswiftcode'];
      this.selectedBankSwiftCode = this.populateObject(this.bankSwiftCodeItems, 'Bank Swift Code', bsc);
      this.bankAccount = data['bankaccno'];
      this.bankCity = data['bankcity'];
      this.isDefaultAccount = data['defaultbank'];
      if (this.isDefaultAccount) {
        this.checkboxDisabled = true;
      } else {
        this.checkboxDisabled = false;
      }
      this.bankName = data['bankname'];
      this.bankBranchName = data['bankbranchname'];
      this.remittanceAdviceEmail = data['emailremittanceadvice'];
      this.lastUpdate = data['eftlastupdate'];
    },
    saveClicked: async function() {
      if (this.viewMode) return;
      if (!this.checkFields()) {
        if (this.isDefaultAccount && !this.checkboxDisabled) {
          let bn = "";
          let ba = "";
          this.eftList.forEach((e) => {
            if (e.eftid == this.defaultAccountID) {
              bn = e.bankname;
              ba = e.bankaccno;
              return;
            }
          })
          let confirm = await this.$showAlert('warning','Switch Default Account', `Are you sure you want to set your default account from ${ba} (${bn}) to this account?`, [{text: 'Confirm'}, {text: 'Cancel'}]);
          if (confirm === 'Confirm') {
            this.eftList.forEach((e) => {
              if (e.eftid == this.defaultAccountID) {
                e.defaultbank = false;
                e.eftaction = 'E';
              }
            })
          }
          else {
            this.isDefaultAccount = false;
            return;
          }
        }

        let temp = this.eftList;
        this.eftList = [];

        let highestID = 0;
        for (let e of temp) {
          if (e.eftid > highestID) {
            highestID = e.eftid;
          }
        }

        let eft = {
          eftaction : this.editIndex > -1 ? 'E' : 'N',
          eftid : this.refid ? this.refid : (++highestID).toString(),
          bankswiftcode : this.selectedBankSwiftCode['Bank Swift Code'],
          bankaccno : this.bankAccount,
          bankcity : this.bankCity,
          defaultbank : this.isDefaultAccount,
          bankname : this.bankName,
          bankbranchname : this.bankBranchName,
          emailremittanceadvice : this.remittanceAdviceEmail,
          eftlastupdate: this.lastUpdate ? new Date(this.lastUpdate).formatString('yyyy-MM-dd HH:mm:ss') : '' ,
        };

        if (this.isDefaultAccount) {
          this.defaultAccountID = this.refid ? this.refid : highestID;
        }

        this.$nextTick(() => {
          if (this.editIndex > -1) {
            if (temp[this.editIndex].eftaction === 'N') {
              eft.eftaction = 'N';
            }
            temp.splice(this.editIndex, 1, eft);
          } else {
            temp.push(eft);
          }
          this.eftList = temp;

          this.clearFields();
          this.$emit("update:showInputs", false);
          this.showDetails = false;
          this.editIndex = -1;

          this.selectedEft = [];

          this.$emit('update:eft', this.eftList);
        })
      }
    },
    cancelClicked: function() {
      this.showDetails = false;
      this.$emit("update:showInputs", false);
      // this.selectedEft = [];
    },
    deleteClicked: function() {
      if (this.selectedEft.length == 0) {
        this.$showAlert('error', 'No Bank Account Selected', 'Please select at least 1 bank account to delete.');
      } else {
        if (this.eftList.length > 1) {
          for (const e of this.selectedEft) {
            if (e.defaultbank) {
              this.$showAlert('error', 'Cannot Delete Default Account', 'Your delete selection consist of the default account as well, please make sure you make another account default first before deleting.');
              return;
            }
          }
        }
        let temp = this.eftList;
        this.selectedEft.forEach(s => {
          let index = temp.findIndex(l => l.eftid === s.eftid);
          temp.splice(index, 1);
        });
        this.eftList = [];

        this.$nextTick(() => {
          this.eftList = temp;
          this.selectedEft = [];

          this.$emit('update:eft', this.eftList);
        });
      }
    },
    clearFields: function() {
      this.refid = '';
      this.selectedBankSwiftCode = null;
      this.bankSwiftCodeError = '';
      this.bankAccount = '';
      this.bankAccountError = '';
      this.bankCity = '';
      this.bankCityError = '';
      this.isDefaultAccount = false;
      this.bankName = '';
      this.bankNameError = '';
      this.bankBranchName = '';
      this.bankBranchNameError = '';
      this.remittanceAdviceEmail = '';
      this.remittanceAdviceEmailError = '';
      this.lastUpdate = '';
      this.checkboxDisabled = false;
      this.editIndex = -1;
    },
    checkFields: function() {
      let error = false;
      if (!this.selectedBankSwiftCode) {
        this.bankSwiftCodeError = 'Bank Swift Code is required!';
        error = true;
      }
      if (!this.bankAccount) {
        this.bankAccountError = 'Bank Account is required!'
        error = true;
      }
      else {
        if (this.bankAccount.length > 25) {
          this.bankAccountError = 'Bank Account cannot exceed 25 digits!'
          error = true;
        }
      }
      if (!this.bankCity) {
        this.bankCityError = 'Bank City is required!'
        error = true;
      }
      else {
        if (this.bankCity.length > 30) {
          this.bankCityError = 'Bank City cannot exceed 30 characters!'
          error = true;
        }
      }
      if (!this.bankName) {
        this.bankNameError = 'Bank Name is required!'
        error = true;
      }
      else {
        if (this.bankName.length > 100) {
          this.bankNameError = 'Bank Name cannot exceed 100 characters!'
          error = true;
        }
      }
      if (this.bankBranchName.length > 100) {
        this.bankBranchNameError = 'Bank Branch Name cannot exceed 100 characters!'
        error = true;
      }
      if (this.remittanceAdviceEmail.length > 100) {
        this.remittanceAdviceEmailError = 'Remittance Advice E-mail cannot exceed 100 characters!'
        error = true;
      }
      return error;
    },
    populateObject: function(data, key, compare) { // To populate object into dropdown or input query
      try {
        return data.find(d => d[key].trim() == (compare ? compare.trim() : ''));
      } catch (error) {
        return null;
      }
    },
    autofillBankDetails: function(selectedCode) {
      if (selectedCode) { 
        this.bankCity = selectedCode['Bank City'];
        this.bankName = selectedCode['Bank Name'];
        this.bankBranchName = selectedCode['Bank Branch Name'];
        this.bankCityError = '';
        this.bankNameError = '';
        this.$nextTick(() => {
          this.$refs["bankAccount"].setFocus();
        });
      }
    }
  },
  async mounted() { 
    this.$fullscreenLoading('Getting Bank Swift Codes');
    let bsc = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'bankswiftcode' });
    this.bankSwiftCodeItems = bsc;

    this.$fullscreenLoading();

    this.eftList = this.eft;
      this.eftList.forEach((e) => {
        if (e.defaultbank == 1) {
          this.defaultAccountID = e.eftid;
        }
      })
  },
  watch: {
    showInputs: function(val) {
      this.showDetails = val;
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.eft-details-main {
  height: calc(100%);
  width: 100%;
  display: flex;
}

.add-remove-eft {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 3px;
}
</style>